<mat-dialog-content>
    <div class="container-fluid pt-lg-2 pb-lg-5 pl-lg-5 pr-lg-5 mr-lg-5 ml-lg-5">
        <div class="d-flex justify-content-center">
            <h3 class="head-text text-color-finzy-blue">Change Bank Details</h3>
        </div>
        <div class="d-flex justify-content-center text-color-darker-grey">
            <p class="text-center">This account will be used for disbursement and EMI recovery.</p>
        </div>
        <div class="pl-lg-5 pr-lg-5">
            <form [formGroup]="formGroup">
                <div class="d-lg-flex d-sm-flex flex-column">
                    <div class="d-lg-flex d-sm-flex mb-lg-4 mb-sm-4">
                        <div class="col-lg-6 col-sm-6 col-xs-12 p-0 mr-lg-3 mr-sm-3 field-cont">
                            <label class="field-label">Account Holder’s Name</label>
                            <input type="text" class="form-control" formControlName="accountHolderName" placeholder="Enter account holder’s name" [(ngModel)]="bankAccount.accountHolderName">
                            <mat-error  class="small" *ngIf="formGroup.controls.accountHolderName.dirty && formGroup.controls.accountHolderName.errors">
                                {{ getErrorMessage(formGroup.controls.accountHolderName) }}
                            </mat-error>
                        </div>
                        <div class="col-lg-6 col-sm-6 col-xs-12 p-0 field-cont">
                            <label class="field-label">Account Type</label>
                            <mat-select class="form-control p-4" placeholder="Select account type" formControlName="accountType" [(ngModel)]="bankAccount.account_type">
                                <mat-option *ngFor="let accountType of accountTypes" [value]="accountType.value">
                                    {{ accountType.viewValue }}
                                </mat-option>
                            </mat-select>
                            <mat-error class="small" *ngIf="formGroup.controls.accountType.dirty && formGroup.controls.accountType.errors">
                                {{ getErrorMessage(formGroup.controls.accountType) }}
                            </mat-error>
                        </div>
                    </div>
                    <div class="d-lg-flex d-sm-flex mb-5" formGroupName="accountNumberGroup">
                        <div class="col-lg-6 col-sm-6 col-xs-12 p-0 mr-lg-3 mr-sm-3 field-cont">
                            <label class="field-label">Account Number</label>
                            <input type="text" class="form-control" formControlName="accountNumber" placeholder="Enter your account number" [(ngModel)]="bankAccount.account_no">
                            <mat-error class="small" *ngIf="formGroup.get('accountNumberGroup').get('accountNumber').dirty && formGroup.get('accountNumberGroup').get('accountNumber').errors">
                                {{ getErrorMessage(formGroup.get('accountNumberGroup').get('accountNumber')) || getErrorMessage(formGroup.get('accountNumberGroup')) }}
                            </mat-error>
                        </div>
                        <div class="col-lg-6 col-sm-6 col-xs-12 p-0 field-cont">
                            <label class="field-label">Verify Account Number</label>
                            <input type="text" class="form-control" formControlName="repeatedAccountNumber" placeholder="Re-enter your account number">
                            <mat-error class="small" *ngIf="formGroup.get('accountNumberGroup').get('repeatedAccountNumber').dirty && formGroup.get('accountNumberGroup').errors">
                                {{ getErrorMessage(formGroup.get('accountNumberGroup')) }}
                            </mat-error>
                        </div>
                    </div>
                    <div class="col-lg-12 col-sm-12 col-xs-12 d-lg-flex mb-4 p-0 align-items-center field-cont">
                        <span class="col-xs-12 col-lg-3 col-md-4 p-0 mr-lg-5">Search bank using:</span>
                        <div class="col-xs-12 p-0 mt-3">
                            <mat-radio-group color="primary" aria-label="Select an option" (change)="onSelectBankDetailsSearch($event)">
                                <mat-radio-button class="mr-sm-3 mr-lg-5 mr-4" value="ifsc">IFSC Code</mat-radio-button>
                                <mat-radio-button value="name">Bank Name</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="">
                        <app-bank-account-details-by-ifsc *ngIf="bankNameSearchSource === 'ifsc'" [bankAccount]="bankAccount"></app-bank-account-details-by-ifsc>
                        <app-bank-account-details-by-name *ngIf="bankNameSearchSource === 'name'" [bankAccount]="bankAccount"></app-bank-account-details-by-name>
                    </div>
                    <div class="d-lg-flex d-sm-flex justify-content-end mt-4">
                        <button [disabled]="isLoading" mat-flat-button  class="secondary-btn btn-cont col-xs-12 col-lg-2 col-sm-3 mr-4 rounded" (click)="onDialogCancel()">CANCEL</button>
                        <button [disabled]="formGroup.invalid || isLoading || !areBankDetailValid()" mat-flat-button
                                class="primary col-xs-12 col-lg-2 col-sm-3 rounded" (click)="updateBankAccount()">UPDATE</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</mat-dialog-content>
